namespace('compass.hotel');

compass.hotel.BookingGridHelperWidget = compass.defineWidget(function BookingGridHelperWidget(options) {
	var me = this;
	var $j = jQuery;
	var d = $j.dom;
	var _settings = options;

	var _message = _settings.message;
	var _arrowPointsAtRoomType = _settings.arrowPointsAtRoomType;
	var _hideArrow = _settings.hideArrow;
	
	this.show = _show;
	this.hide = _hide;
	
	this.render = function(widgetElem) {
		
		var helperContent = d.div({ className : 'helperContent' },
			d.div({ className : 'helperText'}, _settings.message),
			d.div({ className : 'arrow' })
		);
		helperContent.hide();
		widgetElem.append(helperContent);
		
		if (_arrowPointsAtRoomType) me.find('.arrow').addClass('arrow-rotated');
		
		_show();
	};
	
	this.setState = function(newState) {
		if (_settings.lockState) return;
		
		newState.arrowPointsAtRoomType = (newState.arrowPointsAtRoomType === undefined) 
			? _arrowPointsAtRoomType
			: newState.arrowPointsAtRoomType;
			
		newState.hideArrow = (newState.hideArrow === undefined) ? _hideArrow : newState.hideArrow;
		
		// if state hasn't changed, dont do the fade in/out
		var stateHasChanged = (newState.arrowPointsAtRoomType !== _arrowPointsAtRoomType)
			|| (newState.message !== _message) || (newState.hideArrow !== _hideArrow);
		
		if (stateHasChanged) {
			_hide(function callback() {
				_message = newState.message;
				_arrowPointsAtRoomType = newState.arrowPointsAtRoomType;
				_hideArrow = newState.hideArrow;
				
				var arrowEl = me.find('.arrow');
				if (_arrowPointsAtRoomType) arrowEl.addClass('arrow-rotated');
				else arrowEl.removeClass('arrow-rotated');
				
				me.find('.helperText').html(_message);
				_show();
			});
		}
	};
	
	function _show() {
		if(_settings.groupMax <= 1 || _settings.hotelGroupMax <= 1) return;

		me.find('.helperContent').fadeIn(1200);
		
		me.find('.helperText').delay(_settings.showDelay).fadeIn(600, function() {
			if(!_hideArrow) me.find('.arrow').fadeIn(250);
		});
	}
	
	function _hide(callback) {
		me.find('.helperText, .arrow').delay(_settings.showDelay).fadeOut(600, function() {
			if (typeof callback === 'function') return callback();
			else return;
		});
	}

}, {
	WUID : 'defaultBookingGridHelperWidget',
	widgetName : 'BookingGridHelperWidget',
	message : '',
	showDelay : 300,
	arrowPointsAtRoomType : false,
	hideArrow : false,
	lockState : false
});

